import { Box, Divider, List, ListItem, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SegmentOutlinedIcon from "@mui/icons-material/SegmentOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import theme from "../theme";
import useCompetitor from "../provider/competitor_provider";

interface CaOptionsMenuProps {
    open: boolean;
    onClose: () => void;
}

const CaOptionsMenu = ({ open, onClose }: CaOptionsMenuProps) => {
    const ca = useCompetitor();
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    const handleClick = (event: React.MouseEvent, path?: string) => {
        event.stopPropagation();
        ca?.newChat();
        if (path) navigate(path);
        onClose();

    };
    if (!open) return null;

    return (
        <Box
            onClick={onClose}
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.1)",
                zIndex: 999,
            }}
        >
            <Box
                onClick={(e) => e.stopPropagation()}
                sx={{
                    position: "absolute",
                    left: isSmallScreen ? "300px" : "498px",
                    top: isSmallScreen ? "90px" : "59px",
                    fontSize: isSmallScreen ? "0.7125rem" : "0.8125rem",
                    width: isSmallScreen ? "127px" : "auto",
                    background: "white",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    borderRadius: "4px",
                    color: "#374151",
                }}
            >
                <List>
                    <ListItem
                        onClick={(e) => handleClick(e, "/company/annual")}
                        sx={{ gap: "5px", cursor: "pointer" }}
                    >
                        {!isSmallScreen && <AssessmentOutlinedIcon />}
                        Annual Reports
                    </ListItem>
                    {isSmallScreen && <Divider />}
                    <ListItem
                        onClick={(e) => handleClick(e, "/company/segmentwise")}
                        sx={{ gap: "5px", cursor: "pointer" }}
                    >
                        {!isSmallScreen && <SegmentOutlinedIcon />}
                        Segment Wise Reports
                    </ListItem>
                    {isSmallScreen && <Divider />}
                    <ListItem
                        // onClick={(e) => handleClick(e, "/company/nl")}
                        sx={{ gap: "5px", cursor: "pointer" }}
                        disabled={true}
                    >
                        {!isSmallScreen && <PieChartOutlineOutlinedIcon />}
                        NL Reports
                    </ListItem>
                </List>
            </Box>
        </Box>
    );
};

export default CaOptionsMenu;
